import React from 'react';
import {
  FieldContainer,
  FieldCustomMessage,
  FontStyle,
} from '../FieldContainer';
import {
  MultipleTextInput,
  MultipleTextInputMessageStyle,
  MultipleTextInputProps,
} from './MultipleTextInput';

type MultipleTextInputFieldProps = {
  fontStyle?: FontStyle;
  label?: string;
  shouldUseMessageColor?: boolean;
  helpText?: string;
  errorMessage?: string;
  warningMessage?: string;
  customMessage?: FieldCustomMessage | null;
  isHorizontal?: boolean;
  rightChild?: React.ReactNode;
  boldLabel?: boolean;
} & MultipleTextInputProps;

const MultipleTextInputField = ({
  boldLabel,
  customMessage,
  data,
  errorMessage,
  helpText,
  id,
  isHorizontal,
  label,
  maxLength,
  placeholder,
  rightChild,
  shouldUseMessageColor,
  triggerKeys,
  warningMessage,
  modifier,
  onChange,
  onClick,
  validator,
  defaultPillColor = 'white',
  disabled = false,
  fontStyle = FontStyle.default,
  isOnBlur = true,
  maxData = -1,
}: MultipleTextInputFieldProps) => {
  const getMessageStyle = (): MultipleTextInputMessageStyle | null => {
    if (errorMessage) {
      return { type: 'error' };
    } else if (warningMessage) {
      return { type: 'warning' };
    } else if (customMessage) {
      const { color, icon } = customMessage;
      return { type: 'custom', color, icon };
    }
    return null;
  };

  return (
    <FieldContainer
      fontStyle={fontStyle}
      label={label}
      shouldUseMessageColor={shouldUseMessageColor}
      helpText={helpText}
      errorMessage={errorMessage}
      warningMessage={warningMessage}
      customMessage={customMessage}
      isHorizontal={isHorizontal}
      rightChild={rightChild}
      boldLabel={boldLabel}
    >
      <MultipleTextInput
        id={id}
        placeholder={placeholder}
        data={data}
        modifier={modifier}
        triggerKeys={triggerKeys}
        validator={validator}
        onChange={onChange}
        disabled={disabled}
        defaultPillColor={defaultPillColor}
        maxLength={maxLength}
        messageStyle={getMessageStyle()}
        isOnBlur={isOnBlur}
        onClick={onClick}
        maxData={maxData}
      />
    </FieldContainer>
  );
};

export default MultipleTextInputField;
